module.exports = __webpack_public_path__ + "static/media/4 2 tattoo forearm horror macabre visceral gritty demonic.1280x1674.46889dc9.webp";